// extracted by mini-css-extract-plugin
export default {"containerWrapper":"WhyTechnius_containerWrapper__pK59r","container":"WhyTechnius_container__hrzHb","title":"WhyTechnius_title__2wvyV"};